"use client"

import { useEffect, useState } from "react"
import { useInView } from "react-intersection-observer"

import type { UnlikelyProduct } from "@unlikelystudio/commerce-connector"

import { useRecentlyViewed } from "~/hooks/useRecentlyViewed"
import { ProductsSlider } from "~/components/ui/ProductsSlider/index.client"

export function RecentlyViewed({ currentProductId = null }: { currentProductId?: UnlikelyProduct["id"] }) {
  const { ref, inView } = useInView()
  const [isReady, setIsReady] = useState(false)

  const { data: products, isLoading, fetchStatus } = useRecentlyViewed({ enabled: inView })

  useEffect(() => {
    // avoid render mismtatch error
    setIsReady(true)
  }, [])

  if (!products?.length && (!isReady || !isLoading || fetchStatus === "idle")) {
    return <section ref={ref} />
  }

  return (
    <ProductsSlider
      ref={ref}
      isLoading={isLoading}
      title="recently_viewed"
      products={
        products
          ?.filter(Boolean)
          ?.filter((item) => {
            if (!currentProductId) {
              return item
            }

            return item?.id !== currentProductId
          })
          ?.map((item) => ({ product: item, siblings: [] })) ?? []
      }
    />
  )
}
